import React, {Component} from 'react'
import {enableUniqueIds} from '@cred/shared/unique-id'
import {Field} from 'redux-form'
import {Text} from '@cred/react-text'
import PropTypes from 'prop-types'
import {renderError} from '@cred/react-form-field'
import analytics from '@cred/react-analytics/hoc/emitOnChange'
import defaultStyles from './themes/default/styles.module.scss'
import fox1 from './themes/fox1/styles.module.scss'
import withStyles from '@cred/react-theme'

class radioButton extends Component {
  render() {
    const {
      meta: {touched, error},
      input,
      id,
      label,
      size,
      styles
    } = this.props

    return (
      <div className={[styles.radioButton, styles[size], touched && error ? styles.error : ''].join(' ')}>
        <input type="radio" id={id} {...input}/>
        <label htmlFor={id}>
          <Text type="form-field-question">{label}</Text>
        </label>
      </div>
    )
  }
}

const radioButtonWithAnalytics = analytics(radioButton)

class RadioGroup extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['normal', 'small']),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.bool
        ]),
        label: PropTypes.string
      })
    ).isRequired,
    className: PropTypes.string,
    groupLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    mobileGroupLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  }

  static defaultProps = {size: 'normal'}

  constructor(props) {
    super(props)
    enableUniqueIds(this)
  }

  render() {
    const {
      className,
      options,
      groupLabel,
      mobileGroupLabel,
      styles = defaultStyles,
      ...props
    } = this.props

    return (
      <div className={className}>
        <Text type="form-field-question" className="hidden-xs hidden-sm mb-8">
          {groupLabel}
        </Text>
        <Text
          type="form-field-question"
          className="hidden-md hidden-lg hidden-xl mb-8"
        >
          {mobileGroupLabel || groupLabel}
        </Text>
        <div className={styles.radioButtonsWrapper}>
          {options.map((option, index) =>
            <Field
              key={`radio-group${index}`}
              type="radio"
              component={radioButtonWithAnalytics}
              id={index + this.nextUniqueId()}
              label={option.label}
              value={option.value}
              styles={styles}
              {...props}
            />
          )}
          <Field name={props.name} component={renderError} {...props}/>
        </div>
      </div>
    )
  }
}

export {RadioGroup as RadioGroupNoHoc}

export default withStyles(defaultStyles, {fox1})(RadioGroup)
